import {createStyles, Theme} from "@material-ui/core";

export const IconButtonStyle = (theme: Theme) =>
  createStyles({
    root: {
      boxSizing: "border-box",
      padding: theme.spacing(1.25),
      borderRadius: "50%",
    },
    colorPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    colorSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      "&:hover": {
        backgroundColor: theme.palette.secondary.dark,
      },
    }
  });



// WEBPACK FOOTER //
// ./src/components/common/iconButton/iconButton.style.ts